"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingScreen = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LoadingScreen = ({
  isFallbackRunning,
  shouldShowLoadingScreen
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Modal, {
    open: shouldShowLoadingScreen,
    disablePortal: false,
    ...getTestIdProps(_types.TestId.LoadingScreen),
    slots: {
      backdrop: _styles.WhiteBackdrop
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContentWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoadingIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LoadingTitle, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
          in: isFallbackRunning,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleMessage, {
            variant: "h6",
            children: formatMessage('pleaseWaitAsItsTakingLongerThanExpected')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
          in: !isFallbackRunning,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleMessage, {
            variant: "h6",
            children: formatMessage('weAreProcessingYourOrder')
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        children: formatMessage('thisMayTakeAMoment')
      })]
    })
  });
};
exports.LoadingScreen = LoadingScreen;